export default __webpack_public_path__ + "static/media/wenn-eine-tannigi-hose-haet.c978c9f6.pdf";